import { sortSubsessions } from '../utils/sort-subsessions.js';
// Transform session data for the modal
const getSessionDataForModal = (sessionId, sessionsById = {}, speakersById = {}) => {
  const session = sessionsById[sessionId];
  if (!session) return null;

  return {
    ...session,
    title: session.title,
    description: session.description,
    date: session.range,
    location: session.location,
    track: session.track,
    ceuCredits: session.ceu_credits,
    tags: session.tags?.map(tag => tag.name).join(', ') || '',
    tagsList: session.tags?.map(tag => tag.name) || [],
    endTimeAddEvent: session.end_time_addEvent,
    endsAtAddEvent: session.ends_at_addEvent,
    startTimeAddEvent: session.start_time_addEvent,
    startsAtAddEvent: session.starts_at_addEvent,
    timezone: session.timezone,
    speakers:
      session.speakers?.map(speaker => ({
        id: speaker.id,
        name: speaker.full_name,
        role: speaker.role,
        // SB-8853: slug-grouped roles with organizer labels for custom roles.
        role_slug: speaker.role_slug || speaker.role || 'speaker',
        role_label: speaker.role_label || null,
        role_label_plural: speaker.role_label_plural || null,
        salutation: speakersById[speaker.id]?.salutation || speaker.salutation || '',
        honorific: speakersById[speaker.id]?.honorific || speaker.honorific || '',
        title: speakersById[speaker.id]?.title || '',
        company: speakersById[speaker.id]?.company_name || '',
        photo: speakersById[speaker.id]?.photo || '',
        // SB-9832: present only when the org shows current disclosures on embeds.
        disclosure: speakersById[speaker.id]?.disclosure || speaker.disclosure || null,
      })) || [],
    // SB-9083: admin order everywhere subsessions are listed, not just in the modal.
    subsessions: sortSubsessions(session.subsessions || []),
  };
};

const getSpeakerDataForModal = (speakerId, speakersById = {}, sessionsById = {}) => {
  const speaker = speakersById[speakerId];
  if (!speaker) return null;
  return {
    ...speaker,
    sessions: (speaker?.sessions || []).map(session => sessionsById[session.id]),
  };
};

export { getSessionDataForModal, getSpeakerDataForModal };
